<template>
  <div 
    class="toggle-switch"
    :class="{ active: modelValue }"
    @click="toggle"
  >
    <div class="toggle-knob"></div>
  </div>
</template>

<script>
export default {
  name: "ToggleSwitch",
  props: {
    modelValue: Boolean
  },
  emits: ["update:modelValue"],
  methods: {
    toggle() {
      this.$emit("update:modelValue", !this.modelValue);
    }
  }
};
</script>

<style scoped>

.toggle-switch{
width:48px;
height:26px;
background:#e2e8f0;
border-radius:999px;
position:relative;
cursor:pointer;
transition:all .25s ease;
}

.toggle-switch.active{
background:#197fe6;
}

.toggle-knob{
width:22px;
height:22px;
background:white;
border-radius:50%;
position:absolute;
top:2px;
left:2px;
transition:all .25s ease;
box-shadow:0 2px 6px rgba(0,0,0,0.2);
}

.toggle-switch.active .toggle-knob{
transform:translateX(22px);
}

</style>